import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/user-management')({
  beforeLoad: () => getTitleContextSlice('User Management'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
